module.exports = __webpack_public_path__ + "assets/img/two-images-2.6eea7011.jpg";